import { orgManagementClient } from '../../api/clients';
import addConnection from './add-connection/add-connection';
import createConnection from './create-connection/create-connection';
import deleteConnection from './delete-connection/delete-connection';
import getConnections from './get-connections/get-connections';
import updateConnection from './update-connection/update-connection';

const connectionsService = {
  getConnections: getConnections(orgManagementClient),
  addConnection: addConnection(orgManagementClient),
  deleteConnection: deleteConnection(orgManagementClient),
  createConnection: createConnection(orgManagementClient),
  updateConnection: updateConnection(orgManagementClient),
};

export default connectionsService;
